<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y content-class="border-menu" attach max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240" :class="error ? `${fieldClass} error-border-menu` : `${fieldClass} border-menu`")
        .d-flex.align-center.fill-height.px-3
          .flex-grow-1.capitalize.text-left(v-if="value") {{ value }}
          .flex-grow-1.capitalize.neutral500--text.text-left(v-else) {{ $t('type_of_provider_placeholder') }} 
          v-icon(size=16) $yzi-chevron-down
      div.text-xs.danger500--text.ml-3.mt-1.mb-2(v-show="error") This field is required
    v-card.text-xs.white.pt-2
      .sticky.top-0.white
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details)
        v-divider
        template(v-if="showCreateButton")
          .px-4.py-3
            a.info--text.font-semibold(@click="createType") {{ $t('create_provider_type') }} "{{ itemName }}"
          v-divider
      .px-4.py-3.font-semibold {{ $t('existing_type_of_provider') }}
      v-divider
      div.d-flex.justify-center(v-if="isFetching || isDeleting")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-infoT08)")
          div.text-sm.flex-grow-1.neutral700--text {{ item }}
          div.text-xxs.neutral500--text {{ checkSystem(item) }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item }}
          div.text-xxs.neutral500--text(v-if="checkSystem(item)") {{ checkSystem(item) }}
          v-btn(v-else x-small icon color="transparent" @click.stop="deleteItem(item)")
            v-icon(small color="neutral500") mdi-close
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['value', 'error', 'fieldClass'],
  data: () => ({
    isFetching: false,
    itemName: null,
    isDeleting: false,
    show: false,
    items: [],
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      systemProviders: 'clinic/getSystemProviders'
    }),
    showCreateButton() {
      if (this.itemName && !this.filteredItems.length) {
        return true
      }
      return false
    },
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.items.filter(item => (item.toLowerCase().includes(keyword)))
      }
      return this.items
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchProviderTypes()
      } else {
        this.$emit('change')
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProviderTypes () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/`)
        .then(resp => {
          this.items = resp.data.provider_types
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
      this.itemName = ''
    },
    isItemDisabled(item) {
      return this.value === item
    },
    checkSystem (item) {
      let sysitem = this.systemProviders.map(m => m.toLowerCase())
      if (sysitem.includes(item.toLowerCase())) {
        return 'System'
      }
      return ''
    },
    createType () {
      let ptypes = [...this.items]
      ptypes.push(this.itemName)
      this.$axios.patch(`/clinics/${this.company.slug}/`, { provider_types: ptypes })
        .then(() => {
          this.selectItem(this.itemName)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    deleteItem (item) {
      this.isDeleting = true
      let ptypes = this.items.filter(f => f !== item)
      this.$axios.patch(`/clinics/${this.company.slug}/`, { provider_types: ptypes })
        .then(() => {
          this.show = false
          this.itemName = ''
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isDeleting = false
        })
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
</style>